import "./Recommendation.scss";
import RecommendationCard from "../RecommendationCard/RecommendationCard";
import { NavLink, useHistory } from "react-router-dom";
import {
  convertToMilitaryTime,
  loginCheck,
  prepareTimeInterval,
} from "../../utils/helper";

const Recommendation = ({
  recs,
  userData,
  searchTerm,
  subreddits,
  kw,
  postsAnalyzed,
  timeInterval,
}) => {
  const history = useHistory();

  if (kw) {
    let temp = [];
    for (let i = recs.length - 1; i > recs.length - 4; i--) {
      temp.push(recs[i]);
    }
    recs = temp;
  }

  const prepareURL = (rec) => {
    const time = prepareTimeInterval(timeInterval);
    const n = postsAnalyzed.split(" ")[0];

    return `/subreddit-analysis?sr=${rec[0].toLowerCase()}&t=${time}&n=${n}`;
  };

  return (
    <section className="recommendation">
      <div className="recommendation__title-container">
        <h2 className="recommendation__title">Recommendations</h2>
      </div>
      <div className="recommendation__container-bottom">
        {Object.values(recs).map((rec, i) => {
          if (searchTerm) {
            let params = {
              searchTerm: searchTerm,
              dayOfWeek: rec.dayOfWeek.slice(0, 3),
              time: convertToMilitaryTime(rec.timeOfDay.toLowerCase()),
            };

            return (
              <article
                onClick={(e) => {
                  e.preventDefault();
                  loginCheck(params, userData, history);
                }}
                key={i}
                className="recommendation__link"
              >
                <RecommendationCard rec={rec} kw={kw} />
              </article>
            );
          }
          // ELSE it is the Keyword analysis dashboard
          else {
            return (
              <NavLink
                to={() => prepareURL(rec)}
                className="recommendation__link"
                key={i}
              >
                <RecommendationCard rec={rec} subreddits={subreddits} kw={kw} />
              </NavLink>
            );
          }
        })}
      </div>
    </section>
  );
};

export default Recommendation;
